import { createContext } from "react";

export const BenchmarkContext = createContext<{
	benchmarkId?: string;
}>({
	benchmarkId: "",
});
